import React from 'react';
import { useCardBackBannerQuery } from '@trello/graphql/generated';
import { ArchivedCardBanner } from './ArchivedCardBanner';
import { ArchivedListBanner } from './ArchivedListBanner';
import { TemplateCardBanner } from './TemplateCardBanner';

interface CardBackBannerProps {
  idCard: string;
  editable: boolean;
}

export const CardBackBanner: React.FunctionComponent<CardBackBannerProps> = ({
  idCard,
  editable,
}) => {
  const { data, loading, error } = useCardBackBannerQuery({
    fetchPolicy: 'cache-and-network',
    variables: {
      idCard,
    },
  });

  const card = data && data.card ? data.card : null;

  if (!card || loading || error) {
    return null;
  }

  const hasCover = !!(
    card.cover &&
    (card.cover.color ||
      card.cover.idAttachment ||
      card.cover.idUploadedBackground)
  );

  const hasStickers = card.stickers && card.stickers.length > 0;

  if (card.isTemplate) {
    return (
      <TemplateCardBanner
        idCard={idCard}
        hasStickers={hasStickers}
        hasCover={hasCover}
        editable={editable}
      />
    );
  }

  if (card.closed) {
    return <ArchivedCardBanner />;
  }

  if (card.list.closed) {
    return <ArchivedListBanner />;
  }

  return null;
};
